import { translate } from '../../../../common/helpers/translate.helper';
import { OfferHistoryCommercialField, OfferHistoryCoreField } from '../../history/buildOfferHistoryTransitions';

export const getCoreFieldLabel = (field: OfferHistoryCoreField) => {
    switch (field) {
        case 'portId':
            return translate('offer.detail.coreData.port');
        case 'agentId':
            return translate('offer.detail.coreData.agent');
        case 'dateDelivery':
            return translate('offer.detail.coreData.dateDelivery');
        case 'buyerReference':
            return translate('offer.detail.coreData.buyerReference');
        case 'vendorReference':
            return translate('offer.detail.coreData.vendorReference');
        case 'supplyMode':
            return translate('offer.detail.coreData.supplyMode');
        case 'noticeDays':
            return translate('offer.detail.coreData.noticeDays');
        case 'paymentTerms':
            return translate('offer.detail.coreData.paymentTermsLabel');
    }
};

export const getCommercialFieldLabel = (field: OfferHistoryCommercialField) => {
    switch (field) {
        case 'volume':
            return translate('offer.history.field.volume');
        case 'ppl':
            return translate('offer.history.field.ppl');
        case 'total':
            return translate('offer.history.field.total');
    }
};
